import Modal from "common/components/Modal";
import axios from "common/configs/axiosConfigs";
import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ContactCard = ({ c, setContacts }) => {
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const onCancelDelete = () => {
    setIsOpen(false);
  };
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);
  const handleDeleteContact = async () => {
    try {
      const { data } = await axios.post("", {
        action: "deletecontact",
        companyId,
        contactId: c?.id,
      });
      if (data?.success) {
        toast.success(data?.msg);
        setContacts?.((prev) => prev.filter((contact) => contact.id !== c?.id));
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div className="card contact-card h-100">
        <div className="contact-header">
          <div className="contact-header-left">
            <h6>
              {c?.first_name} {c?.last_name}
            </h6>
            <span className="text-muted">{c?.email || "-"}</span>
          </div>
          <div className="ms-auto align-items-center d-flex contact-actions col">
            <a href={`tel:${c?.phone}`} className="bg-success">
              <i className="bi bi-telephone"></i>
            </a>
            <a
              href={`mailto:${c?.email}`}
              className="bg-danger"
              style={{ ...(!c?.email && { opacity: 0.5, pointerEvents: "none" }) }}
            >
              <i className="bi bi-envelope"></i>
            </a>
            <div ref={dropdownRef}>
              <button
                type="button"
                className="p-0 ms-2"
                onClick={() => setIsDropdownOpen((p) => !p)}
              >
                <i className="bi bi-three-dots-vertical fs-20"></i>
              </button>
              <div className={`drop-box ${isDropdownOpen ? "" : "d-none"}`}>
                <Link to={`/contact-details/${c?.id}`}>
                  <i className="me-2 bi bi-eye"></i>View
                </Link>
                <Link to={`/contact/${c?.id}`}>
                  <i className="me-2 bi bi-pencil-square"></i>Edit
                </Link>
                <button type="button" onClick={() => setIsOpen(true)}>
                  <i className="me-2 bi bi-trash3"></i>Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="row gy-3">
          <div className=" col-6">
            <span className="text-muted">Phone no.</span>
            <p>{c?.phone || "-"}</p>
          </div>
          <div className=" col-6">
            <span className="text-muted">Alternative no.</span>
            <p>{c?.alternative_number || "-"}</p>
          </div>
          <div className=" col-6">
            <span className="text-muted">City</span>
            <p>{c?.city || "-"}</p>
          </div>
          <div className=" col-6">
            <span className="text-muted">Pincode</span>
            <p>{c?.pincode || "-"}</p>
          </div>
          <div className="col-12">
            <span className="text-muted">Address</span>
            <p>{c?.address || "-"}</p>
          </div>
        </div>
      </div>
      <Modal {...{ isOpen, onClose: onCancelDelete, title: "Confirmation", size: "sm" }}>
        <>
          <p>Are you sure you want to delete?</p>
          <div className="d-flex mb-n3 pt-3 mt-3 border-top justify-content-end">
            <button type="button" className="btn btn-light me-2" onClick={onCancelDelete}>
              No
            </button>
            <button type="submit" className="btn btn-primary" onClick={handleDeleteContact}>
              Yes
            </button>
          </div>
        </>
      </Modal>
    </>
  );
};

export default ContactCard;
